// component-list.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiservicesService } from '../../../../../Services/Apis/apiservices.service';
import { AddComponentDialogComponent } from './add-component-dialog/add-component-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PermissionService } from '../../../../../components/Authentication/services/permission.service';
import { TranslateDirective } from '../../../../../components/Utilites/Directives/translate.directive';
import { TranslatePipe } from '../../../../../components/Utilites/Pipe/translate.pipe';

// e.g., in a shared file or at top of component-list.component.ts
export interface ComponentDialogData {
  websiteId: number;
  pageId: number;
}

@Component({
  selector: 'app-component-list',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    TranslateDirective,
    TranslatePipe
  ],
  templateUrl: './component-list.component.html',
  styleUrls: ['./component-list.component.scss'],
})
export class ComponentListComponent {
  items: any[] = [];
  loading = false;
  actiondata:any;
  itemLoading: Record<string, boolean> = {};
  constructor(
    private router: Router,
    private _route: ActivatedRoute,
    private apiServices: ApiservicesService,
    private permissionService: PermissionService,
    private dialog: MatDialog
  ) {}

  getPageWiseComponentsList(): void {
    const websiteId = Number(this._route.snapshot?.queryParams['websiteId']);
    const pageId = Number(this._route.snapshot?.queryParams['pageId']);
    this.apiServices
      .getPagewiseComponentsData(websiteId, pageId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res) => {
          this.items = res.rows;
          console.log('row data => ', res.rows);
        },
      });
  }

  ngOnInit(): void {
    this.actiondata = this.permissionService.getactiondata();
    this.getPageWiseComponentsList();
  }
  goBack(): void {
    const websiteId = Number(this._route.snapshot?.queryParams['websiteId']);
    this.router.navigate([`/websites/WebpageList`], {
      queryParams: { websiteId }});
  }

  addPageWiseComponentsList(): void {
    const websiteId = Number(this._route.snapshot?.queryParams['websiteId']);
    const pageId = Number(this._route.snapshot?.queryParams['pageId']);
    const dialogRef = this.dialog.open(AddComponentDialogComponent, {
      width: '700px',
      maxWidth: '85vw',
      minWidth: '300px',
      height: 'auto',
      autoFocus: false,
      disableClose: true,
      panelClass: 'compact-component-dialog',
      data: { websiteId, pageId } as ComponentDialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('result Id', result);
      if (result) {
        this.loading = true;
        this.apiServices
          .addPagewiseComponentsData(
            result.website_id,
            result.website_page_id,
            result
          )
          .pipe(finalize(() => (this.loading = false)))
          .subscribe((response: any) => {
            const index = this.items.findIndex(
              (w: any) => w.id === response.id
            );
            if (index !== -1) {
              this.items[index] = response;
            }
            this.getPageWiseComponentsList();
          });
      }
    });
  }

  editPageWiseComponentsList(website: any): void {
    const dialogRef = this.dialog.open(AddComponentDialogComponent, {
      width: '700px',
      maxWidth: '85vw',
      minWidth: '300px',
      height: 'auto',
      autoFocus: false,
      disableClose: true,
      panelClass: 'compact-component-dialog',
      data: website,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.id) {
        this.loading = true;
        this.apiServices
          .updatePagewiseComponentsData(result.id, result)
          .pipe(finalize(() => (this.loading = false)))
          .subscribe((response: any) => {
            const index = this.items.findIndex(
              (w: any) => w.id === response.id
            );
            if (index !== -1) {
              this.items[index] = response;
            }
            this.getPageWiseComponentsList();
          });
      }
    });
  }

  updatePageWiseComponentsStatus(item: any): void {
    this.itemLoading[item.id] = true;
    const newStatus = item.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';

    this.apiServices
      .updatePagewiseComponentsData(item.id, { ...item, status: newStatus })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((response: any) => {
        const index = this.items.findIndex((w) => w.id === response.id);
        if (index !== -1) {
          this.items[index].status = response.status;
        }
        this.getPageWiseComponentsList();
      });
  }

  ViewItem(item: any) {
    console.log('navigating to item:', item);
    this.router.navigate([
    `/websites/WebcomponentList/`+ item.model_name], {
      queryParams: { websiteId: item.website_id, pageId: item.website_page_id, endpoint: item.model_name}
    });
  }

  deletePageWiseComponentsList(itemId: any): void {
    this.loading = true;
    this.apiServices
      .deletePagewiseComponentsData(itemId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.items = this.items.filter((item) => item.id !== itemId);
          this.getPageWiseComponentsList();
        },
        error: (err) => {
          console.error('Error deleting page:', err);
        },
      });
  }
}
